import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';

interface Trip {
  id: number;
  dotw: string;
  starts_at: string;
  availability: number;
  amount: number;
  discount: number;
}
@Component({
  selector: 'app-tickets-search-results',
  templateUrl: './tickets-search-results.page.html',
  styleUrls: ['./tickets-search-results.page.scss'],
})
export class TicketsSearchResultsPage implements OnInit {
  direction = 'ida';
  user;
  search;
  trips: Trip[];
  price: number;
  discount: number;
  loadingResults: boolean;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private dataService: DataService,
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    this.search = this.dataService.getData('ticket-search');
    if (!this.search) {
      this.navCtrl.navigateBack('/tecservice-transportec/transportec/tickets');
    } else {
      this.getTrips();
    }
    this.authService.getUser().then((user) => {
      this.user = user;
    });
  }

  getTrips() {
    this.loadingResults = true;
    this.apiService
      .getData(
        'trips/' +
          this.search.stop.id +
          '?type=' +
          this.search.type +
          '&date=' +
          this.search.date +
          '&dotw=' +
          new Date(this.search.date).getDay()
      )
      .then((res) => {
        console.log('Trips: ', res);
        this.trips = res.data.trips;
        if (typeof res.data.price !== 'undefined') {
          this.price = res.data.price;
        }
        if (res.data.discount) {
          this.discount = res.data.discount;
        }
      })
      .finally(() => {
        this.loadingResults = false;
      });
  }

  goSummary(trip: Trip) {
    if (trip.availability > 0) {
      trip.amount = this.price;
      trip.discount = this.discount;
      const ticketSelection: { trip: Trip; search; results: Trip[] } = {
        trip,
        search: this.search,
        results: this.trips,
      };
      this.dataService.setData('ticket-summary', ticketSelection);
      this.router.navigate(['/tecservice-transportec/transportec/ticket-summary']);
    }
  }
}
